import { CandidateSpecialty } from 'src/app/recruiting/locums-margin-calculator/models/candidate-details.models';

export interface CandidateDetailsSlice {
    readonly candidateId: number;
    readonly candidateName: string;
    readonly candidateNPI: number;
    readonly professionId: number;
    readonly professionName: string;
    readonly specialties: CandidateSpecialty[];
    readonly selectedSpecialtyId: number;
    readonly providerProfile: string;
    readonly recruiterId: number;
    readonly recruiterName: string;
    readonly errorMessage: string;
}

export const initialCandidateDetailsSlice: CandidateDetailsSlice = {
    candidateId: 0,
    candidateName: '',
    candidateNPI: 0,
    professionId: 0,
    professionName: '',
    specialties: [],
    selectedSpecialtyId: 0,
    providerProfile: '',
    recruiterId: 0,
    recruiterName: '',
    errorMessage: undefined
};
